import { motion } from 'framer-motion';
import { useLanguage } from '@/i18n/LanguageContext';
import { lc } from '@/i18n/copy';
import { Quote } from 'lucide-react';

const copy = {
  en: {
    heading: 'Small words. Big impact.',
    testimonials: [
      'I said something I had held in for years.',
      'This helped me thank my father while I still could.',
      'Simple, beautiful, and private. Exactly what I needed.',
    ],
  },
  es: {
    heading: 'Pequeñas palabras. Gran impacto.',
    testimonials: [
      'Dije algo que había guardado por años.',
      'Esto me ayudó a agradecer a mi padre mientras aún podía.',
      'Simple, hermoso y privado. Exactamente lo que necesitaba.',
    ],
  },
  pt: { heading: 'Poucas palavras. Grande impacto.', testimonials: ['Disse algo que guardei por anos.', 'Isso me ajudou a agradecer meu pai enquanto ainda podia.', 'Simples, bonito e privado. Exatamente o que eu precisava.'] },
  fr: { heading: 'Petits mots. Grand impact.', testimonials: ['J\'ai dit quelque chose que je gardais depuis des années.', 'Cela m\'a aidé à remercier mon père tant que je le pouvais encore.', 'Simple, beau et privé. Exactement ce dont j\'avais besoin.'] },
  ar: { heading: 'كلمات صغيرة. تأثير كبير.', testimonials: ['قلت شيئًا احتفظت به لسنوات.', 'ساعدني هذا على شكر والدي بينما كان لا يزال بإمكاني.', 'بسيط وجميل وخاص. بالضبط ما كنت أحتاجه.'] },
  ja: { heading: '小さな言葉。大きな影響。', testimonials: ['何年も抱えていたことを言えました。', 'まだできるうちに父に感謝する手助けになりました。', 'シンプルで美しくプライベート。まさに必要なものでした。'] },
  ko: { heading: '작은 말. 큰 영향.', testimonials: ['몇 년간 품어왔던 말을 했습니다.', '아직 할 수 있을 때 아버지에게 감사할 수 있었습니다.', '심플하고 아름답고 프라이빗. 딱 필요한 것이었습니다.'] },
  id: { heading: 'Kata-kata kecil. Dampak besar.', testimonials: ['Saya mengatakan sesuatu yang sudah saya simpan bertahun-tahun.', 'Ini membantu saya berterima kasih kepada ayah saya saat masih bisa.', 'Sederhana, indah, dan pribadi. Tepat yang saya butuhkan.'] },

  hi: {
    heading: 'छोटे शब्द। बड़ा प्रभाव।',
    testimonials: [
      'I said something I had held in for years.',
      'This helped me thank my father while I still could.',
      'Simple, beautiful, and private. Exactly what I needed.',
    ],
  },
};

export function SocialProofMinimal() {
  const { language } = useLanguage();
  const t = lc(copy, language);

  return (
    <section className="py-20 md:py-28 bg-muted/20">
      <div className="container max-w-4xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold billboard-flash mb-14 !leading-tight"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {t.heading}
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6">
          {t.testimonials.map((quote, i) => (
            <motion.blockquote
              key={i}
              className="relative p-7 rounded-2xl bg-card border border-border/30 shadow-sm text-left"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
            >
              <Quote className="h-5 w-5 text-secondary/40 mb-3" />
              <p className="text-base text-foreground font-medium leading-relaxed italic">
                "{quote}"
              </p>
            </motion.blockquote>
          ))}
        </div>
        <p className="mt-10 text-sm text-muted-foreground italic">
          Strong connections start with how you speak to yourself.
        </p>
      </div>
    </section>
  );
}
